import { useEffect, useState } from 'react';
import {
  getGoogleConnectUrl,
  isGoogleConnected,
  disconnectGoogle,
  syncAllObligations,
} from '../lib/googleCalendar';

export default function SettingsView() {
  const [connected, setConnected] = useState<boolean | null>(null);
  const [syncing, setSyncing] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    isGoogleConnected().then(setConnected);

    const params = new URLSearchParams(window.location.search);
    const google = params.get('google');
    if (google === 'connected') setMessage('Google Calendar connected.');
    else if (google === 'no_refresh_token')
      setMessage(
        'Google only gave us limited access. Disconnect any prior grant in your Google Account settings, then try connecting again.'
      );
    else if (google === 'error') setMessage('Something went wrong connecting Google Calendar.');
    if (google) window.history.replaceState({}, '', window.location.pathname);
  }, []);

  async function handleConnect() {
    setMessage(null);
    try {
      const url = await getGoogleConnectUrl();
      if (url) window.location.href = url;
    } catch (e) {
      setMessage(e instanceof Error ? e.message : String(e));
    }
  }

  async function handleDisconnect() {
    if (!confirm('Disconnect Google Calendar? Existing events will stay on your calendar.')) return;
    await disconnectGoogle();
    setConnected(false);
  }

  async function handleSyncNow() {
    setSyncing(true);
    setMessage(null);
    try {
      const result = await syncAllObligations();
      setMessage(`Synced ${(result as { synced?: number })?.synced ?? 0} obligations.`);
    } catch (e) {
      setMessage(e instanceof Error ? e.message : String(e));
    } finally {
      setSyncing(false);
    }
  }

  return (
    <div className="settings-view">
      <h1>Settings</h1>

      <section className="card">
        <h2>Google Calendar</h2>
        <p className="muted">
          When connected, every obligation's due date syncs to a dedicated "Nothing Falls
          Through" calendar in your Google account, with reminders. That's what actually
          notifies you, wherever you're signed in to Google.
        </p>

        {connected === null && <p className="muted">Checking…</p>}

        {connected === false && (
          <button className="btn-primary" onClick={handleConnect}>
            Connect Google Calendar
          </button>
        )}

        {connected === true && (
          <div className="settings-actions">
            <span className="badge urgency-ok">Connected</span>
            <button className="btn-secondary" onClick={handleSyncNow} disabled={syncing}>
              {syncing ? 'Syncing…' : 'Sync now'}
            </button>
            <button className="btn-secondary danger" onClick={handleDisconnect}>
              Disconnect
            </button>
          </div>
        )}

        {message && <p className="muted">{message}</p>}
      </section>
    </div>
  );
}
